import AttachmentResource from '@/api/resources/attachment/attachmentResource'

class CaseInternalAttachmentService extends AttachmentResource {
    async getFile(laboratoryId, caseId, attachmentId) {
        return this.axios.get(`/common/laboratories/${laboratoryId}/cases/${caseId}/internalAttachments/${attachmentId}`, {
            headers: { 'content-type': 'multipart/form-data' },
            responseType: 'blob'
        }).then(response => response.data)
    }
}

export default new CaseInternalAttachmentService()
